import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.flag)?_c(VBtn,{staticClass:"ml-n2 mr-2",attrs:{"small":"","color":"primary"},on:{"click":function($event){return _setup.downloadCsv()}}},[_vm._v("\n  Exportar Nerus\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }